<template>
  <div class=" address-page   page-padding-top">
    <top-bar :title="i18n.t('address.title')"  @back="back"></top-bar>

		<div class="address-list" >
			<div class="list flex-center"  v-for="(item, i) in cardList" :key="i" @click="toAdd(item)">
				<div class="icon">
					<img :src="iconObj[item.Protocol]" alt="">
				</div>
				<div class="flex-1 w-1">
					<div class="name">{{item.Name}}</div>
					<div class="desc">{{item.Address ? resetAddress(item.Address) : $t('addAddress.label5')}}</div>
				</div>
				<div class="flex-center status">
					<span :class="item.status == 2 ? 'red' : 'edit'">{{item.status == 1 ? $t('common.edit') : $t(`address.status${item.status}`)}}</span>
					<img :src="warningUrl" alt="" v-if="item.status == 2">
					<img :src="successUrl" alt="" v-else>
				</div>
			</div>
		</div>

  </div>
</template>
<script>
import { Button } from 'vant'
import { addressList } from '@/api/setting'
import topBar from '@/components/topBar'
export default {
  components: {
    topBar,
    Button
  },
  data() {
    return {
      email: 'akdfjlaskjaskjdfasdj@163.com',
      backUrl: require('../../assets/imgs/icon-back.png'),
      warningUrl: require('../../assets/imgs/icon-warning.png'),
      successUrl: require('../../assets/imgs/icon-success.png'),
      iconObj:{
        'USDT-TRC20':  require('../../assets/imgs/bit1.png'),
        'USDT-ERC20':  require('../../assets/imgs/bit2.png'),  
        'USDC-TRC20':  require('../../assets/imgs/bit5.png'),
        'USDC-ERC20':  require('../../assets/imgs/bit5.png'),
        'ETH-ERC20':  require('../../assets/imgs/bit3.png'),
        'BTC':  require('../../assets/imgs/bit4.png'),
      },
      cardList: [
				{
					Protocol: 'USDT-TRC20',
					Name: 'USDT-TRC20',
					Address: '',
					ID: '',
					status: 2,
				},
				{
					Protocol: 'USDT-ERC20',
					Name: 'USDT-ERC20',
					Address: '',
					ID: '',
					status: 2,
				},
				{
					Protocol: 'USDC-TRC20',
					Name: 'USDC-TRC20',
					Address: '',
					ID: '',
					status: 2,
				},
				{
					Protocol: 'USDC-ERC20',
					Name: 'USDC-ERC20',
					Address: '',
					ID: '',
					status: 2,
				},
				{
					Protocol: 'ETH-ERC20',
					Name: 'ETH-ERC20',
					Address: '',
					ID: '',
					status: 2,
				},
				{
					Protocol: 'BTC',
					Name: 'BTC',
					Address: '',
					ID: '',
					status: 2,
				},
			],
      pageType: '',
      rechargeList: ['USDT-TRC20', 'USDT-ERC20', 'USDC-TRC20', 'USDC-ERC20', 'ETH-ERC20', 'BTC'],
      hideAdd: false
    }
  },
  computed: {
    // 已绑定的地址数量
    bindCount() {
      return this.cardList.filter(item => item.status === 1).length
    }
  },
  mounted() {
    this.pageType = this.$route.query.type
    this.init()
  },
  methods: {
    init() {
      addressList({
        current: 1,
        pageSize: 30
      }).then(res => {
        let cardList = res.data.Items
        cardList.forEach(v => {
          let index = this.cardList.findIndex(val => {
            return val.Protocol == v.Protocol
          })
          if (index > -1) {
            this.cardList[index].Address = v.Address
            this.cardList[index].ID = v.ID
            this.cardList[index].status = 1
          }
        })
      })
    },
    back() {
      this.$router.go(-1)
    },
    getCardType(type) {
      let index = 1
      switch(type) {
        case 'USDT-TRC20': index = 1; break;
        case 'USDT-ERC20': index = 2; break;
        case 'USDC-TRC20': index = 5; break;
        case 'USDC-ERC20': index = 5; break;
        case 'ETH-ERC20': index = 3; break;
        case 'BTC': index = 4; break;
      }
      return index
    },
    toAdd(data) {
			sessionStorage.setItem('bitInfo', JSON.stringify({
				icon: this.iconObj[data.Protocol],
				name: data.Name,
				key: data.Protocol
			}))

			if (data.status == 1) {
				this.$router.push({
					name: 'addAddress',
					query: {
						mode: 'edit',
						id: data.ID,
						protocol: data.Protocol,
						address: data.Address
					}
				})
				return
			}

			if (data.status == 2) {
				// 检查是否已达到最大绑定数量
				if (this.bindCount >= 6) {
					this.$toast.fail(this.$t('address.maxBindError'))
					return
				}
				
				this.$router.push({
					name: 'addAddress'
				})
			}
    },
    chooseCard(data) {
      if (this.pageType == 'withdraw') {
        sessionStorage.setItem('withdrawInfo', JSON.stringify(data))
        this.back()
      }
    },
    resetAddress(address) {
      return address.substring(0, 8) + '********' + address.substring(address.length - 8)
    }
  }
}
</script>

<style scoped>
</style>
